import { Box, Link, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setState as ApprovalQuotaState } from "./../Approvals/quota/quotaSlice";
import { setState as ApprovalScenarioState } from "./../Approvals/scenario/scenarioApprovalSlice";
import { setState as ApprovalQuotaModificatioState } from "./../Approvals/quotaModification/quotaModificationSlice";

export default function PendingActionsCard({
  text,
  number,
  redirectionUrl,
  isNavigate,
  selectedCountryID,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  if (isNavigate == "quota") {
    dispatch(ApprovalQuotaState("navigatedCountryID", selectedCountryID));
  } else if (isNavigate == "scenario") {
    dispatch(ApprovalScenarioState("navigatedCountryID", selectedCountryID));
  } else if (isNavigate == "quota-modification") {
    dispatch(
      ApprovalQuotaModificatioState("navigatedCountryID", selectedCountryID)
    );
  }

  function handleClick() {
    navigate(redirectionUrl);
  }

  return (
    <Box
      sx={{
        backgroundColor: "grey.light",
        p: 1,
        borderRadius: 1,
        flex: 1,
        alignItems: "center",
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 550, fontSize: 16 }}>
        {text}
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{ textAlign: "right", color: "blue.main" }}
      >
        {number == 0 && number}
        {number != 0 && (
          <Link sx={{ cursor: "pointer" }} onClick={handleClick}>
            {number}
          </Link>
        )}
      </Typography>
    </Box>
  );
}
